import {
	SET_DATA
} from '../types/contests';

export function setContestData(data) {
  return { type: SET_DATA, data };
}